import {DimensionValue, StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

const VIEWPORT_HEIGHT: DimensionValue = '100vh' as DimensionValue;

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    height: VIEWPORT_HEIGHT,
    maxHeight: VIEWPORT_HEIGHT,
    overflow: 'hidden' as const,
    backgroundColor: white,
  },
  contentLoading: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white,
  },
  tabLayout: {
    width: '100%' as const,
    maxWidth: '100%' as const,
    alignSelf: 'center',
    flex: 0,
    marginHorizontal: 20,
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden' as const,
    backgroundColor: white,
  },
});
